<template>
  <div class="completeinfor">
    <div class="infor-top">
      <div style="width: 1200px; margin: 0 auto; height: 100%">
        <img
          src="../../static/home/logo.png"
          alt=""
          style="
            width: 285px;
            height: 56px;
            display: block;
            float: left;
            margin-top: 17px;
            margin-left: 20px;
          "
        />
      </div>
    </div>
    <div class="user">
      <!-- <div style="width:430px;margin:0 auto;height:40px;margin-bottom:30px;">
                <img src="../../static/home/logo.png" alt="" style="width:254px;height:40px;display:block;">
            </div> -->
      <div class="user-c">
        <!-- 身份 -->
        <div style="overflow: hidden; margin-top: 40px">
          <div
            style="
              float: left;
              width: 430px;
              height: 14px;
              line-height: 14px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
              text-align: right;
            "
          >
            身份
          </div>
          <div
            style="
              width: 350px;
              height: 14px;
              line-height: 14px;
              float: left;
              margin-left: 30px;
            "
          >
            <img
              :src="identityFlag < 3 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('identity', 1)"
            />
            <div style="float: left; margin-right: 40px; font-size: 14px">
              学员
            </div>
            <img
              :src="identityFlag == 3 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('identity', 3)"
            />
            <div style="float: left; font-size: 14px; margin-right: 40px">
              专家
            </div>
            <img
              :src="identityFlag == 4 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('identity', 4)"
            />
            <div style="float: left; font-size: 14px">服务商</div>
          </div>
        </div>
        <!-- 学员 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag < 3"
        >
          <div
            style="
              float: left;
              width: 430px;
              height: 14px;
              line-height: 14px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
              text-align: right;
            "
          ></div>
          <div
            style="
              width: 350px;
              height: 14px;
              line-height: 14px;
              float: left;
              margin-left: 30px;
            "
          >
            <img
              :src="identityFlag == 1 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('identity', 1)"
            />
            <div style="float: left; margin-right: 40px; font-size: 14px">
              有机构学员
            </div>
            <img
              :src="identityFlag == 2 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('identity', 2)"
            />
            <div style="float: left; margin-right: 40px; font-size: 14px">
              无机构学员
            </div>
          </div>
        </div>
        <!-- 服务商模块 -->
        <facilitator v-show="identityFlag == 4"></facilitator>
        <!-- 真实姓名 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag != 4"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            真实姓名
          </div>
          <div class="userinput" style="float: left">
            <input
              type="text"
              placeholder="请输入您的姓名"
              ref="realUserName"
              @blur="realNameBlur"
            />
          </div>
        </div>

        <!-- 性别 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag != 4"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 14px;
              line-height: 14px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            性别
          </div>
          <div
            style="float: left; width: 350px; height: 14px; line-height: 12px"
          >
            <img
              :src="sexFlag == 0 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('sex', 0)"
            />
            <div style="float: left; margin-right: 40px; font-size: 14px">
              男
            </div>
            <img
              :src="sexFlag == 1 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('sex', 1)"
            />
            <div style="float: left; font-size: 14px">女</div>
          </div>
        </div>

        <!-- 身份证号 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag != 4"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            身份证号
          </div>
          <div class="userinput" style="float: left">
            <input
              type="text"
              placeholder="请输入您的身份证号"
              ref="identityNumber"
              @blur="identityNumberBlur"
            />
          </div>
        </div>

        <!-- 选择机构 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag == 1"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            选择机构
          </div>
          <div class="iselect" style="float: left">
            <Select
              v-model="model6"
              style="width: 200px"
              placeholder="请选择机构"
              @on-change="change"
            >
              <Option
                v-for="item in organizationList"
                :value="item.institutionId"
                :key="item.institutionId"
                >{{ item.institutionName }}</Option
              >
            </Select>
          </div>
        </div>

        <!-- 选择班级 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag == 1"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            选择班级
          </div>
          <div class="iselect" style="float: left">
            <!-- <Select v-model="model7" style="width:200px" placeholder="请选择班级">
                            <Option v-for="item in gradeList" :value="item.id" :key="item.id">{{ item.className }}</Option>
                        </Select> -->

            <Select
              v-model="model7"
              filterable
              allow-create
              style="width: 200px"
              placeholder="请选择班级"
            >
              <Option
                v-for="item in gradeList"
                :value="item.id"
                :key="item.id"
                >{{ item.className }}</Option
              >
            </Select>

            <!-- <Select v-model="model17" filterable allow-create @on-create="handleCreate1">
                            <Option v-for="item in cityList3" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select> -->
          </div>
        </div>

        <!-- 请选择 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag == 2"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            请选择
          </div>
          <div class="iselect" style="float: left">
            <Select v-model="model8" style="width: 200px" placeholder="请选择">
              <Option
                v-for="item in crowdList"
                :value="item.value"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </div>
        </div>

        <!-- 邮箱 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag != 4"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            邮箱
          </div>
          <div class="userinput" style="float: left">
            <input
              type="text"
              placeholder="请输入邮箱"
              ref="email"
              @blur="emailBlur"
            />
          </div>
        </div>

        <!-- 所在地区 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag != 1 && identityFlag != 4"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 40px;
              line-height: 40px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            所在地区
          </div>
          <div style="width: 350px; float: left" class="infor-area">
            <Select
              v-model="formValidate.province"
              style="width: 110px; margin-right: 8px; height: 40px"
              @on-change="changeProvince"
              :placeholder="defaultAddress.province"
            >
              <Option
                v-for="item in provinceArr"
                :value="item.encoded"
                :key="item.encoded"
                >{{ item.name }}</Option
              >
            </Select>
            <Select
              v-model="formValidate.city"
              style="width: 110px; margin-right: 8px; height: 40px"
              @on-change="changeCity"
              :placeholder="defaultAddress.city"
            >
              <Option
                v-for="item in cityArr"
                :value="item.encoded"
                :key="item.encoded"
                >{{ item.name }}</Option
              >
            </Select>
            <Select
              v-model="formValidate.county"
              style="width: 110px; margin-right: 0px; height: 40px"
              @on-change="changeCounty"
              :placeholder="defaultAddress.county"
            >
              <Option
                v-for="item in countyArr"
                :value="item.encoded"
                :key="item.encoded"
                >{{ item.name }}</Option
              >
            </Select>
          </div>
        </div>

        <!-- 证件照片 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag != 4"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 114px;
              line-height: 30px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            证件照片
          </div>
          <div style="width: 350px; overflow: hidden; float: left">
            <div style="width: 100%; overflow: hidden">
              <el-upload
                v-loading.fullscreen.lock="fullscreenLoading"
                class="avatar-uploader"
                action="/v1/cloud/user/uploadImagesCardId"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imgFace" :src="imgFace" class="avatar" />
                <div style="width: 170px; height: 114px" v-if="!imgFace">
                  <img
                    src="../../static/common/sfzrm.png"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </el-upload>
              <el-upload
                class="avatar-uploader avatar-uploader-l"
                action="/v1/cloud/user/uploadImagesCardId"
                :show-file-list="false"
                :on-error="handleError2"
                :on-success="handleSuccess2"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imgBack" :src="imgBack" class="avatar" />
                <div style="width: 170px; height: 114px" v-if="!imgBack">
                  <img
                    src="../../static/common/sfzghm.png"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </el-upload>
            </div>
          </div>
        </div>

        <!-- 采集照片 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag != 4"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 114px;
              line-height: 30px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            采集照片
          </div>
          <div style="width: 350px; overflow: hidden; float: left">
            <div style="width: 100%; overflow: hidden">
              <div class="photograph" @click="openMedia()">
                <video
                  id="videoCamera"
                  autoplay
                  style="width: 170px; height: 100px"
                  v-show="!photographShade"
                ></video>
                <div
                  v-show="photographShade"
                  style="width: 170px; height: 100px"
                >
                  <img
                    v-if="selfie == ''"
                    src="../../static/common/cjzp.png"
                    style="width: 170px; height: 100px"
                  />
                  <img
                  v-else
                    :src="selfie"
                    style="width: 170px; height: 100px"
                  />
                </div>
              </div>
              <div
                style="
                  width: 170px;
                  height: 100px;
                  float: left;
                  overflow: hidden;
                  margin-left: 8px;
                "
              >
                <canvas
                  id="canvasCamera"
                  style="width: 170px; height: 100px;display:none"
                ></canvas>
              </div>
            </div>
            <div style="width: 100%; overflow: hidden; margin-top: 10px">
              <div
                id="drawMedia"
                style="
                  float: left;
                  width: 80px;
                  height: 36px;
                  line-height: 36px;
                  border-radius: 3px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: rgba(255, 255, 255, 1);
                  margin-left: 45px;
                "
                @click="drawMedia()"
              >
                拍照
              </div>
              <!-- <Button type="primary" @click="closeMedia()">关闭</Button> -->
              <!-- <Button type="primary" @click="drawMedia()">拍照</Button> -->
            </div>
          </div>
        </div>

        <!-- 状态 -->
        <div
          style="overflow: hidden; margin-top: 20px"
          v-show="identityFlag != 4"
        >
          <div
            style="
              float: left;
              width: 430px;
              text-align: right;
              margin-right: 30px;
              height: 14px;
              line-height: 14px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #666666;
            "
          >
            状态
          </div>
          <div
            style="width: 350px; height: 14px; line-height: 14px; float: left"
          >
            <img
              :src="state == 0 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('state', 0)"
            />
            <div style="float: left; margin-right: 40px; font-size: 14px">
              待业
            </div>
            <img
              :src="state == 1 ? img2 : img1"
              alt=""
              style="
                display: block;
                width: 12px;
                height: 14px;
                float: left;
                margin-right: 10px;
                cursor: pointer;
              "
              @click="identityFn('state', 1)"
            />
            <div style="float: left; font-size: 14px">在职</div>
          </div>
        </div>

        <!-- 清除浮动 -->
        <div style="clear: both"></div>
        <div class="errortext" v-show="identityFlag != 4">
          <!-- {{errortext}} -->
        </div>
        <div class="go" @click="submitFn()" v-show="identityFlag != 4">
          提交信息
        </div>
      </div>
      <!-- <div @click="goIndex()" class="go-home">
                << 返回首页
            </div> -->
    </div>
  </div>
</template>

<script>
import { testFn } from "@/utils/validate";
import areasData from "@/assets/areas.json";
import facilitator from "@/components/complete/facilitator";

export default {
  name: "completeinfor",
  components: {
    facilitator,
  },
  data() {
    return {
      isShow: false, //手机号提示信息
      isConfirm: false, //密码确认
      isChecked: true,
      radio: "0", //身份单选按钮
      sex: "0", //性别
      model6: "",
      model7: "",
      model8: "",
      gradeList: [],
      errortext: "", //提示错误信息
      userNameCheck: true,
      phoneNumberCheck: true,
      pwdCheck: true,
      pwdAgainCheck: true,
      pwd: "",
      identityNumberCheck: true, //身份证号
      teacherCodeCheck: true, //教师编号
      emailCheck: true, //邮箱
      img1: require("../../static/common/xzk.png"), //单选图标
      img2: require("../../static/common/xzdg.png"),
      identityFlag: 1, //身份单选框
      sexFlag: 0, //性别
      state: 0, //状态， 待业和就业
      organizationList: [], //选择机构
      account: localStorage.account, //用户名字

      //上传图片
      imgFace: "", //正面
      imgBack: "", //反面
      cardFace: "", //正面线上地址链接
      cardBack: "", //反面线上地址链接
      selfie: "", //自拍照
      photographShade: true, //遮罩层
      photographFlag: true, //相机展示框
      crowdList: [
        {
          // 人群
          value: "5",
          name: "学生",
        },
        {
          value: "6",
          name: "退役军人",
        },
        {
          value: "7",
          name: "农民",
        },
        {
          value: "8",
          name: "失业人员",
        },
        {
          value: "9",
          name: "其他",
        },
      ],
      //省市区数据
      provinceArr: areasData.data,
      cityArr: [],
      countyArr: [],
      formValidate: {
        province: "",
        city: "",
        county: "",
      },
      defaultAddress: {
        province: "北京市",
        city: "北京市",
        county: "昌平区",
      },
      provinceCode: 0,
      cityCode: 0,
      countyCode: 0, //地区编码

      fullscreenLoading: false, //加载中遮罩层
    };
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleError(res) {
      //未登录跳到登录页
      if (res.status == 401) {
        this.$router.push({ name: "login" });
      }
    },
    handleError2(res) {
      if (res.status == 401) {
        this.$router.push({ name: "login" });
      }
    },
    handleSuccess(res, file) {
      this.imgFace = URL.createObjectURL(file.raw);
      this.cardFace = res;
    },
    handleSuccess2(res, file) {
      this.imgBack = URL.createObjectURL(file.raw);
      this.cardBack = res;
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      // this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      // this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
    },
    identityFn(type, val) {
      if (type == "identity") {
        this.identityFlag = val;
      } else if (type == "sex") {
        this.sexFlag = val;
      } else if (type == "state") {
        this.state = val;
      } else {
      }
    },
    realNameBlur() {
      // let userName = this.$refs.userName.value;
      //判断用户名是否存在
      // this.$axios.get("/v1/muke/student/user/decideaAccount?account="+userName)
      // .then(({data})=>{
      //     if(data.data == 1){
      //         this.userNameCheck = false;
      //         this.errortext = '用户名已存在';
      //     }else{
      //         this.userNameCheck = true;
      //         this.errortext = '';
      //     }
      // })
    },

    phoneNumberBlur() {
      //判断手机号是否存在
      let phoneNumber = this.$refs.phoneNumber.value;
      this.$axios
        .get("/v1/muke/student/user/decideaMobile?mobile=" + phoneNumber)
        .then(({ data }) => {
          if (data.data == 1) {
            this.phoneNumberCheck = false;
            this.errortext = "手机号已存在";
          } else if (
            !/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(this.$refs.phoneNumber.value)
          ) {
            this.phoneNumberCheck = false;
            this.errortext = "请输入正确手机号";
          } else {
            this.phoneNumberCheck = true;
            this.errortext = "";
          }
          console.log("判断手机号是否存在", data);
        });
    },

    pwdBlur() {
      if (this.$refs.pwd.value != "") {
        if (!/^[a-zA-Z0-9_]{8,18}$/.test(this.$refs.pwd.value)) {
          this.pwdCheck = false;
          this.errortext = "密码长度只能在8-18位之间";
        } else {
          this.pwdCheck = true;
          this.errortext = "";
        }
      }
    },
    pwdAgainBlur() {
      if (this.$refs.pwdAgain.value != "") {
        if (this.$refs.pwdAgain.value != this.pwd) {
          this.pwdAgainCheck = false;
          this.errortext = "两次密码输入不一致";
        } else {
          this.pwdAgainCheck = true;
          this.errortext = "";
        }
      }
    },
    identityNumberBlur() {
      let identityNumber = this.$refs.identityNumber.value;
      if (!/^[a-zA-Z0-9_]{18}$/.test(this.$refs.identityNumber.value)) {
        this.identityNumberCheck = false;
        // this.errortext = '身份证号格式错误';
        this.$message.error("身份证号格式错误");
      } else {
        this.identityNumberCheck = true;
        this.errortext = "";
      }

      //判断身份证号是否存在
      // this.$axios.get("/v1/muke/student/user/decideaIdCard?idCard="+identityNumber)
      // .then(({data})=>{
      //     if(data.data == 1){
      //         this.identityNumberCheck = false;
      //         this.errortext = '身份证号已存在';
      //     }else if(!/^[a-zA-Z0-9_]{18}$/.test(this.$refs.identityNumber.value)){
      //         this.identityNumberCheck = false;
      //         this.errortext = '身份证号格式错误';
      //     }else{
      //         this.identityNumberCheck = true;
      //         this.errortext = '';
      //     }
      // })
    },
    iteacherCodeBlur() {
      let teacherCode = this.$refs.teacherCode.value;
      //判断用户名是否存在
      this.$axios
        .get(
          "/v1/muke/student/user/decideaTeacherCard?teacherCard=" + teacherCode
        )
        .then(({ data }) => {
          if (data.data == 1) {
            this.teacherCodeCheck = false;
            this.errortext = "教师编号已存在";
          } else {
            this.teacherCodeCheck = true;
            this.errortext = "";
          }
        });
    },
    emailBlur() {
      //判断邮箱格式是否正确
      let email = this.$refs.email.value;
      if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(this.$refs.email.value)) {
        this.emailCheck = false;
        // this.errortext = '邮箱格式错误';
        this.$message.error("邮箱格式错误");
      } else {
        this.emailCheck = true;
        this.errortext = "";
      }

      // this.$axios.get("/v1/muke/student/user/decideaEmail?email="+email)
      // .then(({data})=>{
      //     if(data.data == 1){
      //         this.emailCheck = false;
      //         this.errortext = '邮箱已存在';
      //     }else if(!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(this.$refs.email.value)){
      //         this.emailCheck = false;
      //         this.errortext = '邮箱格式错误';
      //     }else{
      //         this.emailCheck = true;
      //         this.errortext = '';
      //     }
      //     console.log("判断邮箱是否存在",data);
      // })
    },
    //机构下拉选择框 数据改变事件
    change() {
      for (var i = 0; i < this.organizationList.length; i++) {
        if (this.organizationList[i].institutionId == this.model6) {
          this.gradeList = this.organizationList[i].clazzList;
        }
      }
      this.model7 = ""; //班级数据清空
    },
    goIndex() {
      localStorage.setItem("tabFlag", 1);
      this.$router.push({ name: "home" });
      // sessionStorage.setItem('tabIndex','1');
    },

    //提交 完善信息
    submitFn() {
      this.fullscreenLoading = true;
      let realUserName = this.$refs.realUserName.value;
      // let position = this.radio;
      // let sex = this.sex;
      let institutionId = this.model6 + "";
      let gradeId = this.model7 + "";
      let role = this.model8 + "";
      let identityNumber = this.$refs.identityNumber.value;
      // let teacherCode = this.$refs.teacherCode.value;
      let email = this.$refs.email.value;

      let param = {
        realName: realUserName, //真实姓名
        position: this.identityFlag, //身份 身份 0.教师 1.有机构学员 2.无机构学员
        gender: this.sexFlag, //性别 gender// 0 男 1 女
        institutionId: institutionId, //机构 选填
        classId: gradeId, //选填
        role: role, //人群
        cardNum: identityNumber, //身份证号
        email: email,
        //     teacherCard: teacherCode,  //选填

        // encoded:this.countyCode,
        provinceCode: this.provinceCode, //省
        cityCode: this.cityCode, //市
        areaCode: this.countyCode, //区

        onJob: this.state, //状态  onJob // 0待业 1 在职

        cardFace: this.cardBack, //正面
        cardBack: this.cardFace, //反面
        ownPhoto: this.selfie, // 自己的照片
      };
      console.log(33, param);
      this.$axios
        .post("/v1/cloud/user/perfectMsg", param, {})
        .then(({ data }) => {
          if (data === true) {
            this.fullscreenLoading = false;
            // inforStatus
            localStorage.setItem("completeStatus", "1"); //是否完善信息
            this.$router.push({ name: "home" });
          }
        })
        .catch((error) => {
          this.fullscreenLoading = false;
          if (error.response.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (error.response.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    // 手机文本框得焦事件
    hintMssage() {
      this.isShow = !this.isShow;
    },
    //密码文本框实时监控
    changePassword() {
      if (this.$refs.usPassword.value != "") {
        if (/^[a-zA-Z0-9_]{4,16}$/.test(this.$refs.usPassword.value)) {
          this.isError = false;
          //console.log(this.$refs.passwordNum.value);
        }
      }
    },
    //确认密码文本框的实时监控
    reEnterPassword() {
      var confirmNum = this.$refs.confirmNum.value;
      if (confirmNum != "" && this.$refs.usPassword.value === confirmNum) {
        console.log("密码一致");
        this.isConfirm = false;
      }
    },
    /*function  调用摄像头权限 */
    openMedia() {
      this.photographShade = false;
      var _this = this;
      this.thisCancas = document.getElementById("canvasCamera");
      this.thisContext = this.thisCancas.getContext("2d");
      this.thisVideo = document.getElementById("videoCamera");
      // 一堆兼容代码
      window.URL =
        window.URL || window.webkitURL || window.mozURL || window.msURL;
      // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia ||
            this;
          if (!getUserMedia) {
            // _this.$Message.error("打开摄像头失败！");
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      var constraints = {
        audio: false,
        video: { width: "170px", height: "100px", transform: "scaleX(-1)" },
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          // 旧的浏览器可能没有srcObject
          if ("srcObject" in _this.thisVideo) {
            _this.thisVideo.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            // _this.thisVideo.src = window.URL.createObjectURL(stream)
            _this.thisVideo.src =
              (window.URL && window.URL.createObjectURL(stream)) || stream;
          }
          _this.thisVideo.onloadedmetadata = function (e) {
            _this.thisVideo.play();
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /*function  绘制图片 canvas画图*******/
    drawMedia() {
      if (this.photographShade) {
        return;
      }
      var _this = this;
      // var ratio = _this.thisVideo.videoHeight/_this.thisVideo.videoWidth;
      _this.thisContext.drawImage(_this.thisVideo, 0, 0, 300, 150);
      // 获取图片base64链接
      var image = this.thisCancas.toDataURL("image/png");
      // _this.imgSrc = image
      //上传base64图片
      this.$axios
        .post("/v1/cloud/user/uploadImagesTimeBase", {
          base64: image,
        })
        .then(({ data }) => {
          if (data) {
            this.selfie = data;
            this.closeMedia(); //关闭摄像头
          }
        });
    },
    // 关闭摄像头
    closeMedia() {
      let _this = this;
      this.thisVideo.srcObject.getVideoTracks().forEach(function (track) {
        track.stop();
        _this.photographShade = true;
        //清除画布
        // _this.thisContext.clearRect(0, 0,_this.thisVideo.videoWidth, _this.thisVideo.videoHeight);
      });
    },
    changeProvince(val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (this.formValidate.province == this.provinceArr[i].encoded) {
          this.cityArr = this.provinceArr[i].cityRespList;
          this.formValidate.county = "";
          this.countyArr = [];
        }
      }
      this.provinceCode = val;
    },
    changeCity(val) {
      for (var i = 0; i < this.cityArr.length; i++) {
        if (this.formValidate.city == this.cityArr[i].encoded) {
          this.countyArr = this.cityArr[i].countyRespList;
        }
      }
      this.cityCode = val;
    },
    changeCounty(s) {
      console.log("区", s, this.formValidate.county);
      this.countyCode = s;
    },
  },

  created() {
    // if(localStorage.completeStatus == 0){
    //     this.$router.push('/completeinfor')
    // }

    //机构数据
    this.$axios.get("/v1/cloud/common/institution/all").then(({ data }) => {
      if (data) {
        this.organizationList = data;
      }
    });
  },
  mounted() {},
};
</script>

<style lang="less">
input {
  color: #333 !important;
}
#drawMedia {
  background-color: #3476c1;
  background-image: url("../../static/common/camera.png");
  background-repeat: no-repeat;
  background-position: 14px 13px;
  background-size: 14px 10px;
  text-indent: 38px;
}
//上传图片
.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  float: left;
  width: 170px !important;
  border: 1px solid rgba(238, 238, 238, 1);
}
.avatar-uploader-l .el-upload {
  margin-left: 8px;
}
// .avatar-uploader .el-upload:hover {
//     border-color: #409EFF;
// }
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 182px;
  height: 115px;
  line-height: 115px;
  text-align: center;
}
.avatar {
  width: 182px;
  height: 115px;
  display: block;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.completeinfor {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

  background: #fafafa;

  .infor-top {
    width: 100%;
    height: 80px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 1px 2px 20px 0px rgba(154, 154, 154, 0.2);
    margin-bottom: 40px;
    .infor-top-txt {
      width: 50%;
      float: right;
      text-align: right;
      height: 80px;
      line-height: 80px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #999999;
      margin-right: 30px;
    }
  }

  .user {
    width: 100%;
    height: auto;
    padding-bottom: 30px;
    // background:#f3f3f3;
    .user-c {
      width: 1200px;
      height: auto;
      overflow: hidden;
      margin: 0 auto;
      padding: 0 0px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      .userinput {
        width: 350px;
        height: 40px;
        border: 1px solid rgba(238, 238, 238, 1);
        border-radius: 4px;
        padding-left: 9px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        .getcode {
          width: 100px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #3476c1;
          border-radius: 4px;
          float: right;
          margin: 5px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
        img {
          display: block;
          float: left;
          width: 18px;
          height: 18px;
          margin-left: 16px;
          margin-top: 8px;
          margin-right: 12px;
        }
        input {
          float: left;
          width: 300px;
          height: 100%;
        }
      }
      /*iview 选择框组件*/
      .iselect {
        // ;
        // border:1px solid rgba(238,238,238,1);
        .ivu-select {
          width: 350px !important;
          height: 40px !important;
          line-height: 40px;
        }
        .ivu-select-selection {
          // border-color:rgba(238,238,238,1);
          height: 40px;
          line-height: 40px;
        }
        .ivu-select-single .ivu-select-selection {
          outline: none;
          width: 350px;
          height: 40px;
          line-height: 40px;
        }
        .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
        .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
          width: 350px;
          height: 40px;
          line-height: 40px;
        }
        .ivu-select-single .ivu-select-selection {
          height: 40px;
        }
      }
      .infor-area {
        .ivu-select-selection {
          height: 40px;
          line-height: 40px;
        }
        .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
        .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
          width: 350px;
          height: 40px;
          line-height: 40px;
          color: #999999;
          width: 110px;
        }
        .ivu-select-single .ivu-select-selection {
          height: 40px;
        }
      }

      // .identity{
      //     overflow: hidden;width:100%;height:36px;line-height: 36px;margin-top:7px;
      //     .el-radio__input.is-checked+.el-radio__label {
      //         color:#a7a7a7;
      //     }
      //     .el-radio__label {
      //         padding-left:4px;
      //     }
      //     .el-radio {
      //         margin-right:12px;
      //     }
      //     .el-radio__inner {
      //         width:11px;height:11px;
      //     }
      //     .el-radio__inner::after {
      //         background-color:#707070;width:5px;height:5px;
      //     }
      //     .el-radio__input.is-checked .el-radio__inner {
      //         border-color: #bdbdbd;background: #dddddd;
      //     }
      // }
      .go {
        margin-top: 10px;
        margin-bottom: 37px;
        margin-left: 460px;
        width: 350px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #3476c1;
        border-radius: 4px;
        cursor: pointer;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      .photograph {
        width: 170px;
        height: 100px;
        border: 1px solid rgba(238, 238, 238, 1);
        border-radius: 4px;
        position: relative;
        float: left;
        overflow: hidden;
        // margin-right:10px;
      }
      .errortext {
        width: 100%;
        height: 15px;
        line-height: 15px;
        margin: 8px 0px;
        color: #df0000;
      }
    }
  }
  .go-home {
    width: 430px;
    margin: 0 auto;
    height: 14px;
    line-height: 14px;
    margin-top: 20px;
    text-align: right;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
  }
  .go-home:hover {
    color: #3476C1;
  }
  input::placeholder {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
}
</style>